import { Tab } from '@mui/material';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { QueryTabPanel, QueryTabs } from 'components';
import { AppConfigArea } from 'enums';
import { useQueryTab } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { ConfigsPage } from './ConfigsPage';
import { PayoutOrdersTab } from './PayoutOrderTraderMonitoringTab';
import { PayoutP2PProvidersTab } from './PayoutP2PProvidersTab/PayoutP2PProvidersTab';
import { PayoutRequisitesAutomationTab } from './PayoutRequisitesAutomationTab';

enum Tabs {
  Automation = 'automation',
  P2PProviders = 'p2p_providers',
  Orders = 'orders',
}

const TAB_AREAS: Record<Tabs, AppConfigArea> = {
  [Tabs.Automation]: AppConfigArea.PayoutRequisitesAutomation,
  [Tabs.P2PProviders]: AppConfigArea.PayoutP2PProvider,
  [Tabs.Orders]: AppConfigArea.PayoutOrders,
};

export const PayoutConfigsPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const { tab } = useQueryTab();
  const area = useMemo(() => TAB_AREAS[tab as Tabs], [tab]);

  return (
    <ConfigsPage area={area}>
      <Fragment>
        <QueryTabs tabsEnum={Tabs}>
          <Tab value={Tabs.Automation} label={t('tabs.automation')} />
          <Tab value={Tabs.P2PProviders} label={t('tabs.p2p_providers')} />
          <Tab value={Tabs.Orders} label={t('tabs.orders')} />
        </QueryTabs>
        <QueryTabPanel value={Tabs.Automation}>
          <PayoutRequisitesAutomationTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.P2PProviders}>
          <PayoutP2PProvidersTab />
        </QueryTabPanel>
        <QueryTabPanel value={Tabs.Orders}>
          <PayoutOrdersTab />
        </QueryTabPanel>
      </Fragment>
    </ConfigsPage>
  );
};
